/**
 * Interface-elements (RBAC layout) API.
 */

import apiClient from './api-client';
import type { InterfaceElement } from '@/types/interface-elements.types';
import type { RoleBinding, RoleInterfaceBindingItem } from '@/types/role.types';

/** `GET /interface-elements/:interfaceName` — RBAC layout for one interface. */
export const getInterfaceElements = async (
  interfaceName: string,
  mode?: 'in_person' | 'remote' | 'hybrid',
): Promise<InterfaceElement[]> => {
  const params = mode ? { mode } : {};
  const { data } = await apiClient.get(`/interface-elements/${interfaceName}`, { params });
  return data;
};

/**
 * `GET /interface-elements/all-for-builder` — every element, unfiltered by role.
 * Used by the role permissions builder so menus resolve for all interfaces.
 */
export const getAllInterfaceElementsForBuilder = async (): Promise<
  Record<string, InterfaceElement[]>
> => {
  const { data } = await apiClient.get('/interface-elements/all-for-builder');
  return data;
};

/** `GET /roles/:roleId/interface-elements` */
export const fetchRoleInterfaceBindings = async (
  roleId: string,
): Promise<RoleInterfaceBindingItem[]> => {
  const { data } = await apiClient.get<RoleInterfaceBindingItem[]>(
    `/roles/${roleId}/interface-elements`,
  );
  return data;
};

/** `PUT /roles/:roleId/interface-elements` — replace all bindings. */
export const replaceRoleInterfaceBindings = async (
  roleId: string,
  bindings: RoleBinding[],
): Promise<void> => {
  await apiClient.put(`/roles/${roleId}/interface-elements`, { bindings });
};
